import React, {FC} from "react";
import {Fade, Box} from "@mui/material";
import {UserAvatar} from "../user-avatar";

import {useTranslation} from "next-i18next";
import {SlimUserInterface} from "seacrush-core"
import {useSelector} from "../../store";
import Typography from "@mui/material/Typography";

interface InterestedDiversProps {
  tripId: string;
}

export const InterestedDivers:FC<InterestedDiversProps> = ({tripId}) => {

  const { t } = useTranslation();


  const {interestedByTripId} = useSelector((state) => state.trips)

  const interestedDivers: SlimUserInterface[] = interestedByTripId[tripId] ?? []

  return (
    <>
      {interestedDivers && interestedDivers.length > 0 && (
        <Fade in={true} timeout={400}>
          <Box m={1}>
            <Typography variant={"subtitle1"} sx={{fontStyle: "oblique"}}>
              {t("divers-interested")}:
            </Typography>

            <Box sx={{pl: 2, display: "flex", height: 72, flexWrap: "wrap"}}>
              {interestedDivers.map((user, idx) => {
                return (
                  <UserAvatar
                    key={idx}
                    slimUser={user}
                    alternateBackgroundColor={"#f6f6f6"}
                  />
                );
              })}
            </Box>
          </Box>
        </Fade>
      )}
    </>
  );
}
